export enum CalendarEventsFilterRanges {
    all,
    today,
    next7days,
    next30days,
    allfuture,
    past7days,
    past30days,
    allpast,
}
